module.exports = __webpack_public_path__ + "b86310949af3eefa8af2f7a7413d4444.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C000008WY.png
// module id = 1539
// module chunks = 0